// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.food-menu-listing {
  gap: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/requestEventDetailPage/eventBreakdown/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".food-menu-listing {\n  gap: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 15px;\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
